import { createApp } from 'vue';
import * as ElementPlusIconsVue from '@element-plus/icons-vue';

import ElementPlus from 'element-plus';
// import 'element-plus/dist/index.css'; //now added to scss/element

export function register(app: ReturnType<typeof createApp>) {
	app.use(ElementPlus);
	for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
		app.component(key, component);
	}
}
